import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import PageLoading from "../PageLoading.js";
import "../../pages/styles/SelectSearch.css";
import moment from "moment";
import ReactExport from "react-data-export";
import { BotonExcel, BotonLetras, BotonPDF, BotonCancelar } from "../Plantillas/Botones.js";
import { notificationKardexFechas } from "./KardexNotify.js";
import "../styles/Kardex.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import sunat from "../images/sunat.png";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

function StockGlobal() {
  const history = useHistory();
  const now = moment(new Date()).format("YYYY-MM-DD");

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [FechaFin, setFechaFin] = useState(now);
  const [HoraFin, setHoraFin] = useState("23:59");
  const [productos, setProductos] = useState([]);
  const [displayButton, setDisplayButton] = useState("none");
  const [RUC, setRUC] = useState("");
  const [RazonSocial, setRazonSocial] = useState("");
  const [Establecimiento, setEstablecimiento] = useState("");
  const [FechaHoraInicio, setFechaHoraInicio] = useState(null);

  useEffect(() => {
    setIsLoading(true);
    getDataEmpresa();
    getUltimoReinicio();
  }, []);

  async function getUltimoReinicio() {
    try {
      const res = await fetch("/api/kardex/ultimo-reinicio-stock");
      const data = await res.json();
      setFechaHoraInicio(data.FechaHora || null);
    } catch (err) {
      setFechaHoraInicio(null);
    }
  }

  async function getDataEmpresa() {
    setError(null);
    try {
      const res = await fetch("/api/kardex/InfoEmpresa");
      const data = await res.json();
      setRUC(data[0].Ruc);
      setRazonSocial(data[0].RazonSocial);
      setEstablecimiento(data[0].NombreUbigeo.concat(`- ${data[0].Direccion}`));
    } catch (err) {
      setError(err);
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  }

  function handleFechaChange(e) {
    const { name, value } = e.target;
    if (name === "FechaFin") setFechaFin(value);
    if (name === "HoraFin") setHoraFin(value);
    setDisplayButton("none");
  }

  async function cargarStockGlobal() {
    const fechaFinDatetime = moment(`${FechaFin} ${HoraFin}`);
    if (!FechaFin || !fechaFinDatetime.isValid()) {
      notificationKardexFechas();
      return;
    }
    if (FechaHoraInicio && fechaFinDatetime.isBefore(moment(FechaHoraInicio))) {
      notificationKardexFechas();
      return;
    }

    const params = new URLSearchParams();
    if (FechaHoraInicio) {
      params.set("FechaInicio", moment(FechaHoraInicio).format("YYYY-MM-DD"));
      params.set("HoraInicio", moment(FechaHoraInicio).format("HH:mm"));
    }
    params.set("FechaFin", FechaFin);
    params.set("HoraFin", HoraFin);

    setIsLoading(true);
    setError(null);
    try {
      const res = await fetch(`/api/kardex/stock-global?${params.toString()}`);
      if (!res.ok) throw new Error("Error al obtener stock");
      const json = await res.json();
      const items = json.respuesta || [];
      setProductos(Array.isArray(items) ? items : []);
      setDisplayButton("inline");
    } catch (err) {
      setError(err);
      console.log(err);
      setProductos([]);
    } finally {
      setIsLoading(false);
    }
  }

  function handleSavePDF() {
    const doc = new jsPDF({ orientation: "landscape" });
    doc.setFontSize(10);
    doc.text("STOCK GLOBAL POR RANGO DE FECHAS", 10, 10);
    const textoInicio = FechaHoraInicio ? moment(FechaHoraInicio).format("DD/MM/YYYY HH:mm") : "-";
    const textoFin = moment(`${FechaFin} ${HoraFin}`).format("DD/MM/YYYY HH:mm");
    doc.text(`PERIODO: ${textoInicio} - ${textoFin}`, 10, 18);
    doc.text(`RUC: ${RUC}`, 10, 24);
    doc.text(`RAZÓN SOCIAL: ${RazonSocial}`, 10, 30);
    doc.text(`ESTABLECIMIENTO: ${Establecimiento}`, 10, 36);

    const headers = [["Código", "Cód. barras", "Nombre", "Stock"]];
    const rows = productos.map((p) => [
      p.Codigo || "",
      p.CodigoBarra || "",
      p.Nombre || "",
      String(p.Stock ?? ""),
    ]);
    doc.autoTable({
      head: headers,
      body: rows,
      startY: 44,
      styles: { fontSize: 8 },
      theme: "plain",
    });
    const nombreInicio = FechaHoraInicio ? moment(FechaHoraInicio).format("DD-MM-YYYY_HH-mm") : "inicio";
    doc.save(`stock_global_${nombreInicio}_${moment(FechaFin).format("DD-MM-YYYY")}.pdf`);
  }

  function getDataExportExcel() {
    return [
      {
        columns: [
          { title: "Código", width: { wpx: 120 } },
          { title: "Cód. barras", width: { wpx: 120 } },
          { title: "Nombre", width: { wpx: 250 } },
          { title: "Stock", width: { wpx: 80 } },
        ],
        data: productos.map((row) => [
          row.Codigo || "",
          row.CodigoBarra || "",
          row.Nombre || "",
          row.Stock ?? "",
        ]),
      },
    ];
  }

  if (isLoading && productos.length === 0) {
    return (
      <div>
        <PageLoading />
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="ProcesarBoton mt-1">
        <BotonCancelar onClick={history.goBack} className="ml-4" />
        <div className="ProcesarBotones">
          <BotonPDF
            className="ml-2 mr-2"
            title="Guardar PDF"
            onClick={handleSavePDF}
            style={{ display: displayButton }}
          />
          <ExcelFile
            element={
              <BotonExcel
                type="button"
                title="Guardar Excel"
                style={{ display: displayButton }}
              />
            }
            filename={`Stock global - ${FechaHoraInicio ? moment(FechaHoraInicio).format("DD-MM-YYYY HH-mm") : "inicio"} - ${moment(`${FechaFin} ${HoraFin}`).format("DD-MM-YYYY HH-mm")}`}
          >
            <ExcelSheet dataSet={getDataExportExcel()} name="StockGlobal" />
          </ExcelFile>
          <BotonLetras className="mr-4 ml-2" type="button" onClick={cargarStockGlobal}>
            Cargar
          </BotonLetras>
        </div>
      </div>

      <div className="imgcomprobante">
        <img src={sunat} alt="sunat" />
      </div>

      <div className="kardex__container">
        <div className="kardex">
          <div className="reporteVentasProd">
            <div className="KardexDocumento mb-2">
              <b className="ml-4">Fecha y hora de inicio</b>
              <div className="input__KardexDivSmall">
                <input
                  className="input__linea"
                  type="text"
                  readOnly
                  value={
                    FechaHoraInicio
                      ? moment(FechaHoraInicio).format("DD/MM/YYYY HH:mm")
                      : "Sin reinicio de stock"
                  }
                />
              </div>
            </div>
            <div className="KardexDocumento mb-4">
              <b className="ml-4">*Fecha Fin</b>
              <div className="input__KardexDivSmall">
                <input
                  className="FechaFin input__linea"
                  name="FechaFin"
                  onChange={handleFechaChange}
                  type="date"
                  value={FechaFin}
                  required
                />
              </div>
              <b className="ml-4">*Hora Fin</b>
              <div className="input__KardexDivSmall">
                <input
                  className="input__linea"
                  name="HoraFin"
                  onChange={handleFechaChange}
                  type="time"
                  value={HoraFin}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {productos.length > 0 && (
        <div className="kardex__container mt-3">
          <table className="table table-bordered table-sm">
            <thead>
              <tr>
                <th>Código</th>
                <th>Cód. barras</th>
                <th>Nombre</th>
                <th>Stock</th>
              </tr>
            </thead>
            <tbody>
              {productos.map((row, i) => (
                <tr key={i}>
                  <td>{row.Codigo || ""}</td>
                  <td>{row.CodigoBarra || ""}</td>
                  <td>{row.Nombre || ""}</td>
                  <td>{row.Stock ?? ""}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </React.Fragment>
  );
}

export default StockGlobal;
